module.exports = __webpack_public_path__ + "img/checksurat-min.84a1e643.png";